<a class="logo">
  <img src="/assets/logo/coara.svg" alt="logo coara" class="logo__img" />
  Coara
</a>
